import { isRatesForLoanType } from './isRatesForLoanType';
import type { LoanType } from './types/LoanType';
import type { RateTable } from './types/RateTable';
import { isValidLoanType } from './isValidLoanType';
import { RateTableInternalError } from './RateTableInternalError';

const excludedKeys = ['version'];
const requiredLoanType: LoanType = 'refinance';

export const validateRateTable = (rateTable: RateTable): Promise<RateTable> => {
  const rejectWithError = (message: string) =>
    Promise.reject(new RateTableInternalError(message, rateTable));

  // Ensure the rate table is an object and not null
  if (!rateTable || typeof rateTable !== 'object') {
    return rejectWithError('Rate table is not an object');
  }

  // Extract loan types from the rate table by excluding any keys we expect to not be loan types
  const loanTypes = Object.keys(rateTable).filter(
    (key) => !excludedKeys.includes(key),
  ) as LoanType[];

  // Ensure the required loan type is present in the rate table
  if (!loanTypes.includes(requiredLoanType)) {
    return rejectWithError(`Missing required "${requiredLoanType}" loan type`);
  }

  for (const loanType of loanTypes) {
    // Ensure there are no unexpected loan types
    if (!isValidLoanType(loanType)) {
      return rejectWithError(`Unexpected loan type "${loanType}" found`);
    }

    // Ensure the loan type has the expected structure
    if (!isRatesForLoanType(rateTable[loanType])) {
      return rejectWithError(`Invalid structure for loan type "${loanType}"`);
    }
  }

  return Promise.resolve(rateTable);
};
